import * as _ from "lodash";
import * as log from "loglevel";
import * as React from "react";

import { inject, observer } from "mobx-react";
import { Modal } from "semantic-ui-react";
import { Project } from "../stores/models/project";
import { UIStore } from "../stores/ui-store";
import { ProjectGridItem } from "./projects/project-grid-item";
import { AppStore } from "../stores/app-store";

declare var hopscotch: any;

interface IProjectDashboardProps{
	uiStore?: UIStore;
	appStore?: AppStore;
}

interface IProjectDashboardState{
	project;
	steps;
}


@inject("uiStore", "appStore") @observer
export class IntroModal extends React.Component<IProjectDashboardProps, IProjectDashboardState>{
	constructor(props, state){
		super(props, state);
		this.state = {
			"project": null,
			"steps": []
		};
		this.close = this.close.bind(this);
		this.startTour = this.startTour.bind(this);
	}


	async componentWillMount(){
		let exampleProject = new Project({
			"status": "Live",
			"name": "JUMP Sample Project",
			"description": "Sample Project Description",
			"surveyId": 1234,
			"clientName": "Jibunu",
			"clientProjectName": "Demo_Card",
			"clientNumber": "5555_5",
			"testLinkDue": "2018-01-01",
			"manager": "Jon"
		});
		await this.props.appStore.loadApps(false);
		await exampleProject.loadDemoApps();

		let steps = [];
		steps.push({"title": "Title Bar", "content": "Click the title bar for descriptions of each app available for the project.", "target": "project-name", "placement": "bottom", "showPrevButton": true, "xOffset": -15});
		steps.push({"title": "Pin Project", "content": "Click the horizontal pin icon to keep the project at the top of the page for quick access. Click the vertical pin icon to unpin the project.", "target": "pin-project", "placement": "left", "showPrevButton": true, "yOffset": -15});
		let appLength = exampleProject.userApps.length;
		_.sortBy(exampleProject.userApps, ["name"]).forEach((app, index) => {
			let foundApp = this.props.appStore.findById(app.id);
			if(index > appLength / 2){
				steps.push({"title": foundApp.name, "content": foundApp.description, "target": app.id, "placement": "left", "showPrevButton": true, "yOffset": -25});
			}
			else{
				steps.push({"title": foundApp.name, "content": foundApp.description, "target": app.id, "placement": "bottom", "showPrevButton": true, "xOffset": -25});
			}
		});
		this.setState({
			"project": exampleProject,
			"steps": steps
		},            this.startTour);
	}

	close(){
		this.props.uiStore.setOptionData({"introModal": false});
		hopscotch.endTour([true]);
	}

	startTour(){
		setTimeout(() => {
			hopscotch.startTour({
				"id": "intro-tour",
				"steps": this.state.steps,
				"onEnd": this.close,
				"onClose": this.close
			},                  0);
		},         1000);
	}

	render(){
		return(
		<Modal basic closeIcon={true} open={true} onClose={this.close} closeOnDimmerClick={false} >
			<Modal.Header>Introduction</Modal.Header>
			{this.state.project &&
				<Modal.Description style={{"marginBottom": "25px", "marginTop": "20px"}}>
					<div className="ui one cards centered raised">
						<ProjectGridItem demo={true} project={this.state.project} onTogglePin={() => {}} onEditProject={() => {}} onShowAppControl={() => {}} onShowDetails={() => {}}/>
					</div>
				</Modal.Description>
			}
		</Modal>
		);
	}
}




// WEBPACK FOOTER //
// ./src/views/intro-modal.tsx